import { render } from "./UploadResourceIcon.vue?vue&type=template&id=3749e76d&scoped=true"
import script from "./UploadResourceIcon.vue?vue&type=script&lang=js"
export * from "./UploadResourceIcon.vue?vue&type=script&lang=js"

import "./UploadResourceIcon.vue?vue&type=style&index=0&id=3749e76d&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3749e76d"]])

export default __exports__